import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import { Box } from '@mui/material';
export const ExtensionRatingStars = props => {
    const getStar = (i) => {
        const starsNumber = props.number;
        const fontSize = props.fontSize ?? 'medium';
        if (i <= starsNumber) {
            return _jsx(StarIcon, { fontSize: fontSize }, i);
        }
        if (i > starsNumber && i - 1 < starsNumber) {
            // inline-flex + explicit inset pin the half star exactly over the gray
            // one; an absolute box without offsets sits at its baseline-relative
            // static position and drifts as line-height changes.
            return (_jsxs(Box, { component: 'span', sx: { position: 'relative', display: 'inline-flex' }, children: [_jsx(StarHalfIcon, { fontSize: fontSize, sx: { position: 'absolute', top: 0, left: 0 } }), _jsx(StarIcon, { fontSize: fontSize, sx: { display: 'block', color: '#bcbcbc' } })] }, i));
        }
        return _jsx(StarIcon, { fontSize: fontSize, sx: { color: '#bcbcbc' } }, i);
    };
    return _jsx(_Fragment, { children: [1, 2, 3, 4, 5].map(getStar) });
};
//# sourceMappingURL=extension-rating-stars.js.map